import { Amplify } from 'aws-amplify'
import awsconfig from './aws-exports'

Amplify.configure({
  ...awsconfig,
  Analytics: { autoSessionRecord: false }
})
